function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 7c0 .18-.01.35-.03.52a5.922 5.922 0 01-1.73 3.72A5.944 5.944 0 0113 13H9.87c-.5 0-.92.37-.99.86l-.76 5.28c-.06.39-.34.71-.71.81-.09.04-.18.05-.28.05H5.18a.998.998 0 01-.99-1.16L6.58 4.51A2.997 2.997 0 019.54 2H14c2.76 0 5 2.24 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M21 11c0 1.38-.56 2.63-1.46 3.54-.91.9-2.16 1.46-3.54 1.46h-2.15a1 1 0 00-.99.84l-.72 4.32a1 1 0 01-.99.84H8.22c-.63 0-1.1-.58-.98-1.2l.17-.85c.37-.1.65-.42.71-.81l.76-5.28c.07-.49.49-.86.99-.86H13c1.66 0 3.16-.67 4.24-1.76.97-.96 1.61-2.27 1.73-3.72C20.18 8.21 21 9.51 21 11z"
})));